import * as React from "react";
import { BrComponent } from "@bloomreach/react-sdk";
import { generateConditionalClassNames } from "../../../../utils/containers/RowComponent/utils/utils.js";
const CmsRowPDPContainer = ({ component }) => {
  const { showInDesktop, showInTablet, showInPhone, fullWidth, tabButtonTitle, ...cssStyles } = component.getParameters();
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const rowClassName = generateConditionalClassNames("br-row-pdp", {
    fullWidth,
    showInDesktop,
    showInTablet,
    showInPhone
  });
  return /* @__PURE__ */ React.createElement("div", { className: rowClassName, "data-t": "br-row-pdp", style: { ...filteredStyles } }, /* @__PURE__ */ React.createElement(BrComponent, null));
};
export {
  CmsRowPDPContainer,
  CmsRowPDPContainer as default
};
//# sourceMappingURL=RowPDPContainer.js.map
